import iconv from 'iconv-lite'

export const useContractorCsvErrorReportDownload = () => {
  const createCsvData = async (url: string) => {
    const response = await fetch(url)
    if (!response.ok) {
      throw new Error('Failed to download file')
    }

    // UTF-8のCSVデータを、文字コードShift_JIS（MS932）、改行コードCRLFに変換する
    const arrayBuffer = await response.arrayBuffer()
    const utf8Text = new TextDecoder('utf8').decode(new Uint8Array(arrayBuffer))
    const normalizedText = utf8Text.replace(/\r\n|\r/g, '\n')
    const textWithCRLF = normalizedText.replace(/\n/g, '\r\n')
    const shiftJisBuffer = iconv.encode(textWithCRLF, 'MS932')
    return new Blob([new Uint8Array(shiftJisBuffer)], { type: 'application/octet-binary' })
  }

  return {
    createCsvData,
  }
}
